import { Button as PrimeButton } from 'primereact/components/button/Button';
import React from 'react';

const Button: React.FC<
  React.ComponentProps<typeof PrimeButton> & {
    className?: string;
    type?:
      | 'primary'
      | 'secondary'
      | 'success'
      | 'danger'
      | 'warning'
      | 'info'
      | 'light'
      | 'dark'
      | 'link'
      | 'greenLink';
    buttonType?: 'button' | 'submit' | 'reset';
    icon?: string;
    iconPos?: 'left' | 'right';
    loading?: boolean;
  }
> = (props) => {
  const { buttonType, type, loading, ...rest } = props;
  return (
    <PrimeButton
      {...rest}
      type={buttonType || 'button'}
      label={props.label}
      className={`${props.className || ''} p-button-${type || 'primary'}`}
      icon={props.loading ? 'pi pi-spin pi-spinner' : props.icon}
      iconPos={props.iconPos || (props.loading ? 'right' : 'left')}
      disabled={props.loading || props.disabled}
    />
  );
};

export default Button;
